import { HttpInterceptorFn } from '@angular/common/http';

export const AuthInterceptor: HttpInterceptorFn = (req, next) => {
  const token = localStorage.getItem('jwtToken'); // your stored key

  // ✅ Do NOT attach JWT to public endpoints
  const isPublic =
    req.url.includes('/api/customer/invite/') ||
    req.url.includes('/api/auth/') ||
    req.url.includes('/actuator/');

  if (isPublic) {
    return next(req);
  }

  if (token) {
    const authReq = req.clone({
      setHeaders: { Authorization: `Bearer ${token}` }
    });
    return next(authReq);
  }

  return next(req);
};

